// Identity and tenancy entities (data-model.md "Identity and tenancy").
import { z } from "zod";
import { AccountId, MembershipId, PlanId, UserId } from "../ids.js";
import { Timestamp } from "./common.js";
import { Locale, MembershipRole, PlanName } from "./enums.js";
/** An ISO-3166 alpha-2 country code (two uppercase letters). */
const CountryCode = z.string().regex(/^[A-Z]{2}$/, "must be an ISO-3166 alpha-2 code");
/** The tenant. */
export const Account = z.object({
    id: AccountId,
    name: z.string().trim().min(1),
    planId: PlanId,
    /**
     * CR-016 (07-change-queue.md:56) additive fold. The plan NAME (solo|studio|business) so the web
     * can select the Solo-vs-Studio/Business CTA copy (ux spec §2.7). OPTIONAL and resolved
     * server-side later: the api session join + a db plan_name-on-accounts column are the coordinated
     * Wave-2 change. Optional keeps every existing Account consumer green - the api session.service.ts
     * Account.parse (session.service.ts:41) and the model.test.ts round-trip both omit it - so this is
     * an expand step, never forced (app-engineering §10). Reuses the existing PlanName enum (enums.ts,
     * mirrored by the db plan_name pgEnum) - one source of truth, no new value set. Not a §D36
     * violation: the entitlement gate is server-side; only CTA copy depends on this.
     */
    planName: PlanName.optional(),
    country: CountryCode,
    vatId: z.string().trim().min(1).nullable(),
    foundingRateLockedUntil: Timestamp.nullable(),
    createdAt: Timestamp,
});
/** A person. Identity/auth is owned by Better Auth; this is the domain-facing view. */
export const User = z.object({
    id: UserId,
    email: z.email(),
    name: z.string().trim().min(1),
    locale: Locale,
    createdAt: Timestamp,
});
/** A user's role within one account. Roles: owner / admin / viewer. */
export const Membership = z.object({
    id: MembershipId,
    accountId: AccountId,
    userId: UserId,
    role: MembershipRole,
});
//# sourceMappingURL=identity.js.map